import React, { useState, useEffect, Fragment } from "react";
import { Form } from "react-bootstrap";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { Formik } from "formik";
import MedicalRegistrationSchema from "./ValidationSchema/MedicalRegistrationSchema";
import FileSelector from "../UI Component/FileSelector/FileSelector";
import API_Call from "../../Util/API Calls/afterLogin";
import Loader from "../UI Component/Loader/Loader";
import swal from "sweetalert";
import { withRouter } from "react-router";
import Icon_delete_solid from "./images/Icon_delete_solid.svg";
import DownloadNew from "../../assets/download_new.png";

const MedicalRegistration = (props) => {
  const [state, setState] = useStateWithCallbackLazy({
    submitMedicalRegistration: false,
    loading: false,
    uploadedDocs: {},
    medicalRegistrationRertificateData: [],
    govtIssuedPhotoUrl: [],
    signatureUrl: [],
  });

  const [isTrue, setIsTrue] = useState(false);
  const [gvIsTrue, setGvIsTrue] = useState(false);
  const [sgnIsTrue, setSgnIsTrue] = useState(false);

  useEffect(() => {
    getFileDetails();
  }, []);

  useEffect(() => {
    if (props.isFilled.submitMedicalRegistration) {
      setState({ ...props.isFilled });
    }
  }, []);

  useEffect(() => {
    uploadDocument("medical_registration_certificate_url");
  }, [state.medical_registration_certificate_url]);

  useEffect(() => {
    uploadDocument("govt_issued_photo_url");
  }, [state.govt_issued_photo_url]);

  useEffect(() => {
    uploadDocument("signature_url");
  }, [state.signature_url]);

  const Medical_Registration_fields_Initial_Value = {
    medical_reg_no: props.isFilled.submitMedicalRegistration
      ? props.isFilled.medical_reg_no
      : "",
    referral_code: props.referral_code,
  };

  const imageSelectHandler = (image, name, picker) => {
    setState({
      ...state,
      [picker]: false,
      [name]: image,
      disableSubmitButton: false,
    });
  };

  const imageValidation = () => {
    return !(
      // state.govt_issued_photo_url?.upload &&
      // state.medical_registration_certificate_url?.upload &&
      // state.signature_url?.upload

      (
        state.medicalRegistrationRertificateData.length !== 0 &&
        state.govtIssuedPhotoUrl.length !== 0 &&
        state.signatureUrl.length !== 0
      )
      // state.profile_picture_url?.upload &&
      // state.checkbook_url?.upload
    );
  };

  const submitHandler = async (allValues, { setSubmitting, resetForm }) => {
    const values = MedicalRegistrationSchema.cast(allValues);

    setState({ ...state, ...values, loading: true });
    if (values.referral_code === "") {
      setState({ ...state, loading: false });
      if (imageValidation()) {
        setState({
          ...state,
          showImageError: true,
        });
        setSubmitting(false);
        return;
      }
      setSubmitting(true);
      setState({ ...state, ...values, loading: true });
      API_Call.post("/public/create-doctor-onboard-application", {
        step: "3",
        is_agreed: "on",
        doctor_application_id: localStorage.getItem("doctor_application_id"),
        ...values,
      })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 200) {
              setState({
                ...state,
                ...values,
                submitMedicalRegistration: true,
                loading: false,
              });

              props.submitData({
                ...values,
                ...state,
                submitMedicalRegistration: true,
              });

              const Msg = swal({
                title: "Doctor Onboarding Request Submitted Successfully!",
                text: "Customer Happiness Team will review the application. You will be soon notified once your application is processed.",
                icon: "success",
                button: "OK",
              }).then(() => {
                localStorage.removeItem("doctor_application_id");
                if (localStorage.getItem("user_type") == "support") {
                  props.history.push("/admin/onboardrequests");
                } else {
                  props.history.push("/doctor/login");
                }
              });
              return Msg;
            } else {
              setState({ ...state, loading: false });
              const Msg = swal({
                title: "Invalid Submission",
                text: response.data.message
                  ? response.data.message
                  : response.data.errorMessage,
                icon: "warning",
                button: "OK",
              });
              return Msg;
            }
          } else {
            setState({ ...state, loading: false });
            const Msg = swal({
              title: "Server Error",
              text: "Something went wrong",
              icon: "danger",
              button: "OK",
            });
            return Msg;
          }
        })
        .catch((err) => {
          setState({ ...state, loading: false });
          const Msg = swal({
            title: "Server Error",
            text: err.message,
            icon: "danger",
            button: "OK",
          });
          return Msg;
        });
    } else {
      API_Call.post("/public/validate-referral-code", {
        referral_code: values.referral_code,
      })
        .then((res) => {
          if (res.status === 200) {
            setState({ ...state, loading: false });
            if (res.data.statusCode === 200) {
              if (imageValidation()) {
                setState({
                  ...state,
                  showImageError: true,
                });
                setSubmitting(false);
                return;
              }
              setSubmitting(true);
              setState({ ...state, ...values, loading: true });
              API_Call.post("/public/create-doctor-onboard-application", {
                step: "3",
                is_agreed: "on",
                doctor_application_id: localStorage.getItem(
                  "doctor_application_id"
                ),
                ...values,
              })
                .then((response) => {
                  if (response.status === 200) {
                    if (response.data.statusCode === 200) {
                      setState({
                        ...state,
                        ...values,
                        submitMedicalRegistration: true,
                        loading: false,
                      });

                      props.submitData({
                        ...values,
                        ...state,
                        submitMedicalRegistration: true,
                      });

                      const Msg = swal({
                        title:
                          "Doctor Onboarding Request Submitted Successfully!",
                        text: "Customer Happiness Team will review the application. You will be soon notified once your application is processed.",
                        icon: "success",
                        button: "OK",
                      }).then(() => {
                        localStorage.removeItem("doctor_application_id");
                        if (localStorage.getItem("user_type") == "support") {
                          props.history.push("/admin/onboardrequests");
                        } else {
                          props.history.push("/doctor/login");
                        }
                      });
                      return Msg;
                    } else {
                      setState({ ...state, loading: false });
                      const Msg = swal({
                        title: "Invalid Submission",
                        text: response.data.message
                          ? response.data.message
                          : response.data.errorMessage,
                        icon: "warning",
                        button: "OK",
                      });
                      return Msg;
                    }
                  } else {
                    setState({ ...state, loading: false });
                    const Msg = swal({
                      title: "Server Error",
                      text: "Something went wrong",
                      icon: "danger",
                      button: "OK",
                    });
                    return Msg;
                  }
                })
                .catch((err) => {
                  setState({ ...state, loading: false });
                  const Msg = swal({
                    title: "Server Error",
                    text: err.message,
                    icon: "danger",
                    button: "OK",
                  });
                  return Msg;
                });
            } else {
              setState({ ...state, loading: false });
              const Msg = swal({
                title: "Invalid Submission",
                text: res.data.message,
                icon: "warning",
                button: "OK",
              });
              return Msg;
            }
          } else {
            setState({ ...state, loading: false });
            const Msg = swal({
              title: "Server Error",
              text: "Something went wrong",
              icon: "danger",
              button: "OK",
            });
            return Msg;
          }
        })
        .catch((err) => {
          setState({ ...state, loading: false });
          const Msg = swal({
            title: "Server Error",
            text: err.message,
            icon: "danger",
            button: "OK",
          });
          return Msg;
        });
    }
  };

  const uploadDocument = (name) => {
    if (state[name]?.value) {
      let url = name;
      let targetUpload = state[name];
      setState({ ...state, loading: true });
      API_Call.post("/public/upload-application-details", {
        [name]: state[name],
        doctor_application_id: localStorage.getItem("doctor_application_id"),
      }).then((response) => {
        setState({ ...state, loading: false });
        if (response.status === 200) {
          if (response.data.statusCode === 200) {
            targetUpload.upload = true;
            setState({ ...state, [url]: targetUpload });
            const Msg = swal({
              title: "SUCCESS",
              text: response.data.message,
              icon: "success",
              button: "OK",
            }).then((msg) => {
              getFileDetails();
            });
            return Msg;
          } else {
            const Msg = swal({
              title: "Invalid Submission",
              text: response.data.message,
              icon: "warning",
              button: "OK",
            });
            return Msg;
          }
        } else {
          const Msg = swal({
            title: "Something went Wrong",
            text: response.statusText,
            icon: "danger",
            button: "OK",
          });
          return Msg;
        }
      });
    }
  };

  const renderErrors = (errors, touched) => {
    let errorsToRender = [];
    for (let error in errors) {
      if (touched[error] && error !== "status" && error !== "is_agreed") {
        let errorToRender = errors[error];
        errorToRender = errorToRender[0].toUpperCase() + errorToRender.slice(1);
        errorsToRender.push(errorToRender);
      }
    }
    if (errorsToRender.length > 1)
      return (
        <div className={"invalid-feedback d-block"}>
          Please fill all the mandatory fields
        </div>
      );
    return errorsToRender.map((error) => (
      <div className={"invalid-feedback d-block"}>{error}</div>
    ));
  };

  const getFileDetails = () => {
    setState({ loading: true });
    API_Call.post("/public/get-upload-application", {
      doctor_application_id: localStorage.getItem("doctor_application_id"),
    }).then((response) => {
      if (response.data.statusCode === 200) {
        setState({ loading: false });
        setState({
          uploadedDocs: response.data.uploaded_docs,
          medicalRegistrationRertificateData:
            response.data.uploaded_docs.medical_registration_certificate_url,
          govtIssuedPhotoUrl: response.data.uploaded_docs.govt_issued_photo_url,
          signatureUrl: response.data.uploaded_docs.signature_url,
        });
        if (
          response.data.uploaded_docs.medical_registration_certificate_url
            .length >= 5
        ) {
          setIsTrue(true);
        } else {
          setIsTrue(false);
        }

        if (response.data.uploaded_docs.govt_issued_photo_url.length >= 1) {
          setGvIsTrue(true);
        } else {
          setGvIsTrue(false);
        }

        if (response.data.uploaded_docs.signature_url.length >= 1) {
          setSgnIsTrue(true);
        } else {
          setSgnIsTrue(false);
        }
      }
    });
  };

  const medicalRegistrationRertificateEachDataDelete = (index, data) => {
    if ("medical_registration_certificate_url" === data) {
      API_Call.post("/public/delete-upload-application", {
        doctor_application_id: localStorage.getItem("doctor_application_id"),
        medical_registration_certificate_url: [
          state.medicalRegistrationRertificateData[index].path,
        ],
      }).then((response) => {
        if (response.data.statusCode === 200) {
          getFileDetails();
        }
      });
    }
    if ("govt_issued_photo_url" === data) {
      API_Call.post("/public/delete-upload-application", {
        doctor_application_id: localStorage.getItem("doctor_application_id"),
        govt_issued_photo_url: [state.govtIssuedPhotoUrl[index].path],
      }).then((response) => {
        if (response.data.statusCode === 200) {
          getFileDetails();
        }
      });
    }
    if ("signature_url" === data) {
      API_Call.post("/public/delete-upload-application", {
        doctor_application_id: localStorage.getItem("doctor_application_id"),
        signature_url: [state.signatureUrl[index].path],
      }).then((response) => {
        if (response.data.statusCode === 200) {
          getFileDetails();
        }
      });
    }
  };

  return (
    <Fragment>
      {state.loading ? <Loader /> : null}

      <section
        id="side_tab3"
        className="item active"
        data-title="Medical Registration Number & Document Upload"
      >
        <div className="item-content">
          <div className="personal-info">
            <div className="info-ttl">
              <h2>Medical Registration Number & Document Upload</h2>
            </div>
            <div className="info-form">
              <Formik
                onSubmit={submitHandler}
                initialValues={Medical_Registration_fields_Initial_Value}
                validationSchema={MedicalRegistrationSchema}
                enableReinitialize
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  handleBlur,
                  errors,
                  touched,
                  isSubmitting,
                }) => (
                  <form noValidate onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-8 col-sm-6">
                        <div className="form-group">
                          <label>
                            Medical Registration Number<span>*</span>
                          </label>
                          <Form.Control
                            required
                            className="cstom-control"
                            placeholder="Medical Registration Number"
                            name={"medical_reg_no"}
                            value={values.medical_reg_no}
                            isInvalid={
                              errors.medical_reg_no && touched.medical_reg_no
                            }
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.medical_reg_no}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-8 col-sm-6">
                        <div className="form-group">
                          <label>Employee Referral Code</label>
                          <Form.Control
                            className="cstom-control"
                            placeholder="e.g. 123456"
                            name={"referral_code"}
                            value={values.referral_code}
                            onChange={handleChange}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.referral_code}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                    </div>
                    <div className="undertaking-document">
                      <div className="document-undertaking-text">
                        <b className="undertaking-bold-text">
                          Undertaking Document
                        </b>
                        <p className="mb-0">
                          You can download the undertaking document, sign and
                          upload it using the option below.
                        </p>
                      </div>
                      <a
                        className="download-form"
                        href="https://c2c-public-content.s3.ap-south-1.amazonaws.com/doctor_undertaking_form/undertaking_V2.pdf"
                        target="_blank"
                      >
                        <img src={DownloadNew} />
                        <b className="ml-2">Download Form</b>
                      </a>
                    </div>
                    <div className="row">
                      <div className="col-lg-12 col-sm-12">
                        <h5 className="upload_doc_heading">Upload Documents</h5>
                      </div>
                      <div className="col-lg-12 col-sm-12">
                        <Form.Group className="upload-res-crtf txtt upload_file_discription_box mt20">
                          <div className="upload_file_discription">
                            <p
                              className="upload-doc"
                              style={{ minHeight: "100px" }}
                            >
                              Registration Certificate/ Highest Degree
                              Certificate & Undertaking Document{" "}
                              <span className="clr"> * </span>
                              <span
                                className="sub_heading"
                                style={{ display: "block" }}
                              >
                                (png/jpeg/jpg only)
                              </span>
                              <span
                                className="sub_heading"
                                style={{ display: "block" }}
                              >
                                (You can add upto 5 documents)
                              </span>
                            </p>
                          </div>
                          <div className="upload_file_box">
                            <div className="p-image">
                              <FileSelector
                                name="medical_registration_certificate_url"
                                accept={" .jpg, .jpeg, .png "}
                                maxFileSize={4}
                                onSelect={(image) =>
                                  imageSelectHandler(
                                    image,
                                    "medical_registration_certificate_url",
                                    "pickMedicalPicture"
                                  )
                                }
                                isTrue={isTrue}
                              />
                              <p
                                className="text-danger"
                                style={{
                                  paddingLeft: "0px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}
                              >
                                MAX FILE SIZE: 4 MB
                              </p>
                              {state.showImageError && !state.loading ? (
                                state.medicalRegistrationRertificateData
                                  .length === 0 ? (
                                  <small
                                    className="text-danger"
                                    style={{
                                      fontSize: "10px",
                                      position: "absolute",
                                    }}
                                  >
                                    Medical Registration Certificate photo must
                                    be uploaded
                                  </small>
                                ) : null
                              ) : null}

                              {isTrue ? (
                                <p className="text-danger p-0 error_text_upload">
                                  <small>
                                    You have already uploaded 5 files, please
                                    delete to upload new.
                                  </small>
                                </p>
                              ) : null}
                            </div>

                            {state.medicalRegistrationRertificateData &&
                              state.medicalRegistrationRertificateData.map(
                                (
                                  medicalRegistrationRertificateEachData,
                                  index
                                ) => (
                                  <div
                                    className="uploadd-dp multiple_image_box"
                                    key={index}
                                  >
                                    <div className="circle">
                                      <div className="profile_pic_cobt">
                                        <img
                                          className="profile-pic"
                                          src={
                                            medicalRegistrationRertificateEachData.path
                                          }
                                        />
                                      </div>
                                      <div className="upload_doc_text_cont">
                                        <Form.Text className="text-muted upload-doc image-name">
                                          {
                                            medicalRegistrationRertificateEachData.file_name
                                          }
                                        </Form.Text>
                                      </div>
                                      <div className="icon_delete_solid_cont">
                                        <img
                                          className="icon_delete_solid"
                                          src={Icon_delete_solid}
                                          alt=""
                                          onClick={() =>
                                            medicalRegistrationRertificateEachDataDelete(
                                              index,
                                              "medical_registration_certificate_url"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        </Form.Group>
                      </div>
                      <div className="col-lg-12 col-sm-12">
                        <div className="upload-res-crtf txtt upload_file_discription_box ">
                          <div className="upload_file_discription">
                            <p
                              className="upload-doc"
                              style={{ minHeight: "100px" }}
                            >
                              Govt ID Proof <span className="clr"> * </span>{" "}
                              <span style={{ display: "block" }}>
                                Eg Passport, Voter's ID, Driving License,
                                Aadhaar Card and PAN card
                              </span>
                              <span
                                className="sub_heading"
                                style={{ display: "block" }}
                              >
                                (png/jpeg/jpg only)
                              </span>
                            </p>
                          </div>
                          <div className="upload_file_box">
                            <div className="p-image">
                              <FileSelector
                                name={"Government Id Proof"}
                                maxFileSize={4}
                                accept={" .jpg, .jpeg, .png "}
                                onSelect={(image) =>
                                  imageSelectHandler(
                                    image,
                                    "govt_issued_photo_url",
                                    "pickGovtPicture"
                                  )
                                }
                                isTrue={gvIsTrue}
                              />
                              <p
                                className="text-danger"
                                style={{
                                  paddingLeft: "0px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}
                              >
                                MAX FILE SIZE: 4 MB
                              </p>
                              {state.showImageError && !state.loading ? (
                                state.govtIssuedPhotoUrl.length === 0 ? (
                                  <small
                                    className="text-danger"
                                    style={{
                                      fontSize: "10px",
                                      position: "absolute",
                                    }}
                                  >
                                    Government ID proof must be uploaded
                                  </small>
                                ) : null
                              ) : null}

                              {gvIsTrue ? (
                                <p className="text-danger p-0 error_text_upload">
                                  <small>
                                    You have already uploaded a file, Please
                                    delete to upload new.
                                  </small>
                                </p>
                              ) : null}
                            </div>

                            {state.govtIssuedPhotoUrl &&
                              state.govtIssuedPhotoUrl.map(
                                (govtIssuedPhotoUrlEachData, index) => (
                                  <div
                                    className="uploadd-dp multiple_image_box"
                                    key={index}
                                  >
                                    <div className="circle">
                                      <div className="profile_pic_cobt">
                                        <img
                                          className="profile-pic"
                                          src={govtIssuedPhotoUrlEachData.path}
                                        />
                                      </div>
                                      <div className="upload_doc_text_cont">
                                        <Form.Text className="text-muted upload-doc image-name">
                                          {govtIssuedPhotoUrlEachData.file_name}
                                        </Form.Text>
                                      </div>
                                      <div className="icon_delete_solid_cont">
                                        <img
                                          className="icon_delete_solid"
                                          src={Icon_delete_solid}
                                          alt=""
                                          onClick={() =>
                                            medicalRegistrationRertificateEachDataDelete(
                                              index,
                                              "govt_issued_photo_url"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-12 col-sm-12">
                        <div className="upload-res-crtf txtt upload_file_discription_box">
                          <div className="upload_file_discription">
                            <p
                              className="upload-doc"
                              style={{ minHeight: "100px" }}
                            >
                              Signature <span className="clr"> * </span>{" "}
                              <span
                                className="sub_heading"
                                style={{ display: "block" }}
                              >
                                (png/jpeg/jpg only)
                              </span>
                            </p>
                          </div>
                          <div className="upload_file_box">
                            <div className="p-image">
                              <FileSelector
                                name={"Signature Photo"}
                                maxFileSize={0.5}
                                accept={" .jpg, .jpeg, .png "}
                                onSelect={(image) =>
                                  imageSelectHandler(
                                    image,
                                    "signature_url",
                                    "pickSignPicture"
                                  )
                                }
                                isTrue={sgnIsTrue}
                              />
                              <p
                                className="text-danger"
                                style={{
                                  paddingLeft: "0px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}
                              >
                                MAX FILE SIZE: 500 KB
                              </p>
                              {state.showImageError && !state.loading ? (
                                state.signatureUrl.length === 0 ? (
                                  <small
                                    className="text-danger"
                                    style={{
                                      fontSize: "10px",
                                      position: "absolute",
                                    }}
                                  >
                                    Signature Photo must be uploaded
                                  </small>
                                ) : null
                              ) : null}

                              {sgnIsTrue ? (
                                <p className="text-danger p-0 error_text_upload">
                                  <small>
                                    You have already uploaded a file, Please
                                    delete to upload new.
                                  </small>
                                </p>
                              ) : null}
                            </div>

                            {state.signatureUrl &&
                              state.signatureUrl.map(
                                (signatureUrlEachData, index) => (
                                  <div
                                    className="uploadd-dp multiple_image_box"
                                    key={index}
                                  >
                                    <div className="circle">
                                      <div className="profile_pic_cobt">
                                        <img
                                          className="profile-pic"
                                          src={signatureUrlEachData.path}
                                        />
                                      </div>
                                      <div className="upload_doc_text_cont">
                                        <Form.Text className="text-muted upload-doc image-name">
                                          {signatureUrlEachData.file_name}
                                        </Form.Text>
                                      </div>
                                      <div className="icon_delete_solid_cont">
                                        <img
                                          className="icon_delete_solid"
                                          src={Icon_delete_solid}
                                          alt=""
                                          onClick={() =>
                                            medicalRegistrationRertificateEachDataDelete(
                                              index,
                                              "signature_url"
                                            )
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <ul style={{ fontSize: "13px" }}>
                        <li style={{ padding: "0 10px" }}>
                          - In case an unintended image file is uploaded, please
                          click on the corresponding “Choose File” button again
                          and select the correct image to replace
                        </li>
                        <li style={{ padding: "0 10px" }}>
                          - Please ensure that any image file that needs to be
                          uploaded is lesser than 4MB in size
                        </li>
                      </ul>
                    </div>

                    <div className="col-12 pb-2">
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="rejected"
                          onClick={() =>
                            setState({
                              ...state,
                              submitMedicalRegistration:
                                !state.submitMedicalRegistration,
                            })
                          }
                          checked={state.submitMedicalRegistration}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="rejected"
                        >
                          I accept the{" "}
                          <a
                            href="/terms.html"
                            target="_blank"
                            style={{ color: "#17a2b8" }}
                          >
                            terms and conditions
                          </a>
                        </label>
                      </div>
                    </div>
                    <div className="save-next d-flex">
                      <button
                        type="button"
                        className="custom-bck"
                        disabled={isSubmitting}
                        onClick={() => props.previousTab("Bank Information")}
                      >
                        <i className="fa fa-angle-left"></i> Back{" "}
                      </button>
                      <button
                        type="submit"
                        className="custom-btnn"
                        disabled={!state.submitMedicalRegistration}
                      >
                        Submit
                        {/* <i className="fa fa-angle-right"></i> */}
                      </button>
                    </div>
                    <div className={"d-flex mt-3"}>
                      <div className="ml-auto">
                        {renderErrors(errors, touched)}
                      </div>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default withRouter(MedicalRegistration);
